import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

// selectors
import { isDealListCompareEnabled } from '@makemydeal/dr-shared-store/selectors/featureToggleSelectors';

// actions
import { setCustomerVehiclesSlideoutVisibility } from '@makemydeal/dr-sales-checkin-store';
import { setDealListCompareEnabled } from '@makemydeal/dr-activities-customer-vehicles';

/**
 * Custom hook to manage customer vehicles slideout state and actions
 * @returns Object containing handleClose callback
 */
export const useCustomerVehiclesSlideout = () => {
    const dispatch = useDispatch();
    const compareEnabled = useSelector(isDealListCompareEnabled);

    // Close slideout handler
    const handleClose = () => {
        dispatch(setCustomerVehiclesSlideoutVisibility(false));
    };

    // Sync the compare toggle value to the package whenever it changes
    useEffect(() => {
        dispatch(setDealListCompareEnabled(compareEnabled));
    }, [compareEnabled, dispatch]);

    return {
        handleClose
    };
};
